<template>
  
  <el-row :gutter="10" style="border: 2px solid #ccc;">
    <el-col :span="0"></el-col>
    <div style="border: 2px">
      <input type="file" ref="fileInput">
      <el-button @click="uploadFile" type="large">上传文件</el-button>
      <div v-if="fileUrl">Uploaded file URL: {{ fileUrl }}</div>
    </div>
  </el-row>

  <div id="files-container">
    <div id="files-list">
      <el-table :data="filesList" style="width: 100%" border stripe highlight-current-row>
        <el-table-column prop="id" label="文件编号" align="center" width="150">
        </el-table-column>
        <el-table-column prop="fileName" label="文件名" align="center">
        </el-table-column>
        <el-table-column prop="fileUrl" label="文件路径" align="center">
        </el-table-column>
        <el-table-column prop="companyName" label="公司名称" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="上传时间"  align="center">
        </el-table-column>
        <el-table-column label="操作" width="150">
      <template #default="scope">
        <!--<el-button type="primary" icon="el-icon-edit" size="small" circle @click="edit(scope.row)">下载</el-button>
        <el-button type="danger" icon="el-icon-delete" size="small" circle @click="del(scope.row.fileUrl)">删除</el-button>-->
    
        <el-button
            size="mini"
            @click="handleLoad(scope.$index, scope.row.fileUrl)">下载</el-button>
        <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row.id)">删除</el-button>
      
      </template>
    </el-table-column>
      </el-table>
      <div class="pagination-tools">
        <!--
            background:带背景的页码
            layout：分页条布局
                prev：上页按钮
                pager：页码
                next：下一页按钮
                sizes:每页显示数量
                jump：跳转到第几页
                ->：定位其内容居右显示
                total：总条目数
            :page-size.sync="pageParam.pageSize":每页条目数   问题1
            :current-page.sync="pageParam.pageNum"：当前页码  问题2
            :page-sizes="pageSizes"：条目列表
            :total="total"：总条目数
            :hide-on-single-page="true":当只有一页时隐藏分页条
        -->
        <el-pagination
            background
            layout="sizes,prev, pager, next,jumper,->,total"
            :page-size="this.pageParam.pageSize"
            :current-page="this.pageParam.pageNum"
            :page-sizes="pageSizes"
            :total="total"
            :hide-on-single-page="true"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>



<script>
import axios from 'axios';
import { baseUrl_New } from '../../axios/urlconfig';
import { ElMessage } from 'element-plus';
export default {
  name:'files-list',
  data() {
    return {
      filesList: [],
      //分页设置
      pageParam: {//分页参数
        pageNum: 1,//当前页
        pageSize: 10,//每页条目数据
      },
      total: 0,//总条目数
      pageSizes: [10, 20, 30, 40],//每页显示条目数列表
    }

  },
  
  methods: {
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pageParam.pageSize = val;
      this.getUsersList();
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.pageParam.pageNum = val;
      this.getUsersList();
    },
    getUsersList() {
      axios.get(baseUrl_New + '/oss/file/page/'+ this.pageParam.pageNum + '/' + this.pageParam.pageSize)
          .then(response => {
            // console.log(response);
            //获得服务器端回传的map对象
            let resultMap = response.data;
            //从集合中获取用户列表及总条目数
            this.filesList = resultMap.list;
            this.total = resultMap.total;
          })
          .catch(err => {
            ElMessage.error(err)
          })
    },
    handleDelete(index, id){
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.delete(baseUrl_New + `/oss/file/del/${id}`)
        .then(response=>{
          // console.log(response);
            if (response.data.code == 0){
              this.$message.success("删除成功")
                this.getUsersList();
            }else{
              this.message.error("删除失败");
              }
        })
      })
     },
   
     handleLoad(index, fileUrl) {
      this.$confirm('确定下载此文件?', '提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      }).then(() => {
    axios.get(baseUrl_New + '/oss/file/downloadFile?fileUrl=' + fileUrl, {
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/octet-stream'
    }
  }).then(response => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    const filename = fileUrl.substring(fileUrl.lastIndexOf('/') + 1);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
  })
});
},

uploadFile() {
        const file = this.$refs.fileInput.files[0];
        const formData = new FormData();
        formData.append('file', file);
        axios.post(baseUrl_New+'/oss/file/upload', formData).then((response) => {
//        if(response != null){
 //           alert("上传成功");
 //       }else if(response.fileUrl === null || response.fileUrl === '' || response.fileUrl === undefined){
 //           alert("上传失败");
  //      }
          ElMessage.success("上传成功");
          // console.log(response.data);
          this.fileUrl = response.data.fileUrl;
          this.getUsersList();
        }).catch((error) => {
          ElMessage.error("上传失败，请选择文件");
          console.log(error);
        });
      },
  },


  created() {
    this.getUsersList();
  }
}
</script>

<style>
.pagination-tools {
  margin-top: 10px;
  text-align: center;
}
</style>
